var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.8 50",
    style: {
      enableBackground: "new 0 0 59.8 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EF3F3F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.4,11.4c7.4,0,14.7,0,22.1,0c1.2,0,1.7,0.5,1.7,1.7c0,1,0,2.1,0,3.1c0,0.9-0.5,1.4-1.4,1.5 c-0.2,0-0.3,0-0.5,0c-14.6,0-29.2,0-43.8,0c-0.3,0-0.5,0-0.8,0c-0.6-0.1-1.1-0.6-1.1-1.2c0-1.3,0-2.6,0-3.8c0-0.7,0.6-1.2,1.2-1.2 c0.2,0,0.4,0,0.5,0C11.7,11.4,19,11.4,26.4,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,7.4c0.5,0,0.9,0,1.3,0c0.5,0,0.8,0.2,0.8,0.7c0,0.6,0,1.2,0,1.8c-3.6,0-7.1,0-10.6,0c0-0.7,0-1.3,0-2 c0-0.4,0.3-0.6,0.7-0.6c0.4,0,0.9,0,1.4,0c0-0.7,0-1.4,0-2.1c0-0.8,0.2-1,1-1c1.5,0,3.1,0,4.6,0c0.6,0,0.9,0.2,0.9,0.9 C17,6,17,6.7,17,7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.6,10c0-0.7,0-1.3,0-1.9c0-0.4,0.3-0.6,0.7-0.6c0.4,0,0.9,0,1.4,0c0-0.7,0-1.4,0-2.1c0-0.7,0.2-0.9,0.9-0.9 c1.6,0,3.1,0,4.7,0c0.7,0,0.9,0.2,0.9,0.9c0,0.7,0,1.4,0,2.2c0.4,0,0.8,0,1.2,0c0.6,0,0.8,0.2,0.9,0.9c0,0.6,0,1.1,0,1.7 C40.7,10,37.2,10,33.6,10z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.8,24.1c0,3.4,0,6.8,0,10.2c0,0.3-0.1,0.6-0.4,0.8c-1.3,1-1.9,2.2-1.7,3.8c0.2,2.2,2.2,3.8,4.2,3.7 c0-0.5,0-0.9,0-1.4c-0.1,0-0.2,0-0.3,0c-1.2-0.1-2.3-1.1-2.5-2.2c-0.2-1.3,0.5-2.8,2.1-3.3c0-0.1,0-0.2,0-0.3c0-2.9,0-5.7,0-8.6 c0-0.1,0-0.2,0-0.4c0.1-0.3,0.4-0.5,0.7-0.5c0,0,0,0,0,0c0-1.4,0-2.7,0-4.1c-0.3,0-0.6,0-0.9,0.2C46.2,22.5,45.8,23.2,45.8,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4,39.5c-0.3-2.1,0.3-3.8,1.9-5.2c0.1-0.1,0.2-0.2,0.2-0.4c0-3.2,0-6.5,0-9.7c0-1.9,1-3.2,2.9-3.6 c0,0,0,0,0.1,0c0.2,0,0.4,0,0.6,0c0-0.3,0-0.6,0-1c0-0.2,0-0.3,0-0.5c-14.4,0-28.8,0-43.2,0c0,0.2,0,0.4,0,0.5c0,7.8,0,15.6,0,23.4 c0,0.8,0.2,1,1,1c13.7,0,27.4,0,41.2,0c0.2,0,0.3,0,0.4,0C44.9,43.8,42.8,41.9,42.4,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4,38.5c0,0.8,0.7,1.4,1.4,1.4c0,0,0.1,0,0.1,0c0-0.9,0-1.9,0-2.8c0,0-0.1,0-0.1,0 C47,37.1,46.4,37.7,46.4,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.2,33.8c0-3.2,0-6.5,0-9.7c0-1.7-1-3-2.5-3.4c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.2,0-0.3,0c0,0.5,0,0.9,0,1.4 c1,0.1,1.9,0.9,1.9,2c0,1.7,0,3.5,0,5.2c0,0,0,0,0,0c0,1.7,0,3.4,0,5.2c0,0.3,0.1,0.6,0.4,0.8c1.4,1.1,2,2.5,1.6,4.2 c-0.4,1.7-1.4,2.8-3.1,3.2c-0.3,0.1-0.5,0.1-0.8,0.1c0,0.1,0,0.3,0,0.4c0,0.7-0.1,0.9-0.6,1c0.5,0,1.1,0,1.6-0.1 c2.2-0.5,3.6-1.9,4.2-4c0.6-2.2-0.1-4-1.7-5.6C51.3,34.1,51.2,34,51.2,33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.4,24.7c0.3,0,0.7,0,1,0c0.3,0,0.6,0,1,0c0.2,0,0.4-0.1,0.5-0.1c0.3-0.1,0.3-0.5,0.3-0.7 c-0.1-0.3-0.3-0.5-0.7-0.5c-0.7,0-1.3,0-2,0c-0.5,0-0.8,0.3-0.8,0.7C52.6,24.4,52.9,24.7,53.4,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.4,27.4c0.3,0,0.7,0,1,0c0.3,0,0.7,0,1,0c0.4,0,0.8-0.3,0.8-0.7c0-0.4-0.3-0.7-0.8-0.7c-0.7,0-1.3,0-2,0 c-0.5,0-0.8,0.3-0.8,0.7C52.6,27.1,52.9,27.4,53.4,27.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.3,28.8c-0.3,0-0.7,0-1,0c-0.3,0-0.7,0-1,0c-0.5,0-0.8,0.3-0.8,0.7c0,0.4,0.3,0.7,0.8,0.7c0.7,0,1.3,0,2,0 c0.4,0,0.7-0.3,0.7-0.7C56.1,29.1,55.8,28.8,55.3,28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.3,31.5c-0.7,0-1.3,0-2,0c-0.5,0-0.8,0.3-0.8,0.7c0,0.4,0.3,0.7,0.8,0.7c0.3,0,0.7,0,1,0c0.3,0,0.7,0,1,0 c0.5,0,0.8-0.3,0.8-0.7C56.1,31.8,55.8,31.5,55.3,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.5,39.2c0.2-0.6,0.1-1.3-0.1-1.9c-0.4-0.8-1-1.4-1.9-1.6c0-1,0-2.1,0-3.1c0-2,0-4,0-5.9 c0-0.4-0.2-0.6-0.6-0.7c0,3.7,0,7.4,0,11c0.7,0.1,1.3,0.7,1.3,1.4c0,0.7-0.6,1.3-1.3,1.4c0,0.5,0,0.9,0,1.4 C49.2,41.2,50.2,40.4,50.5,39.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery3);
export default __webpack_public_path__ + "static/media/battery-3.fb3b686f232eed0d05686e7861f7ac8c.svg";
export { ForwardRef as ReactComponent };